import type { SkillGroup } from '@portfolio/shared';

/** Skills grouped by capability rather than presented as a keyword cloud. */
export const skillGroups: readonly SkillGroup[] = [
  {
    id: 'frontend',
    title: 'Frontend engineering',
    description: 'The core stack used daily across enterprise product work.',
    skills: [
      'React',
      'Next.js',
      'TypeScript',
      'JavaScript ES6+',
      'React Hooks',
      'React Router',
      'Redux',
      'RxJS',
      'HTML5',
      'CSS3',
      'Sass',
    ],
  },
  {
    id: 'architecture',
    title: 'Architecture and performance',
    description: 'How applications are structured and kept fast as they grow.',
    skills: [
      'Frontend architecture',
      'Component architecture',
      'Design systems',
      'Storybook',
      'Server-side rendering',
      'Code splitting',
      'Lazy loading',
      'Rendering and bundle optimization',
      'Accessibility and WCAG practices',
    ],
  },
  {
    id: 'testing',
    title: 'Testing and quality',
    description: 'Test tooling used to keep behavior verifiable during change.',
    skills: ['Playwright', 'React Testing Library', 'Jest', 'Cypress'],
  },
  {
    id: 'integration',
    title: 'APIs and real-time integration',
    description: 'Connecting interfaces to services, streams and AI workflows.',
    skills: [
      'REST APIs',
      'GraphQL',
      'Apollo Client',
      'WebRTC',
      'Real-time event streams',
      'Kafka',
      'RabbitMQ',
    ],
  },
  {
    id: 'backend',
    title: 'Backend and data',
    description: 'Supporting full-stack capability alongside the frontend specialization.',
    skills: ['Node.js', 'NestJS', 'Express.js', 'Python', 'FastAPI', 'PostgreSQL'],
  },
  {
    id: 'cloud',
    title: 'Cloud and delivery',
    description: 'Build, deployment and collaboration tooling.',
    skills: ['Docker', 'AWS', 'Azure', 'Webpack', 'Git', 'GitLab', 'Agile', 'Scrum'],
  },
];

/** Additional technologies used across the career, listed without grouping. */
export const supportingTechnologies: readonly string[] = [
  'Vue.js',
  'Svelte',
  'AngularJS',
  'React Native',
  'jQuery',
  'Bootstrap',
  'Sencha Touch',
  'PHP',
  'MySQL',
  '.NET',
];
